const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const deleteLineItems = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'DELETE_INVOICE_ITEMS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'DELETE_INVOICE_ITEMS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default deleteLineItems;